import { useMemo } from 'react'

import { NestedDropdown } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'

import { DownloadApiLink } from '~/portal/components/ApiViewer/DownloadApiDropdown/DownloadApiLink'
import { AsyncAPIDefinition, OpenAPI2Definition, OpenAPI3Definition } from '~/portal/types/api.definitions'
import { API_DOWNLOAD_FORMATS } from '~/portal/types/downloadApi'

export const DownloadApiDropdown = ({
  title,
  definition,
  disabled = false,
}: {
  title: string,
  definition: OpenAPI2Definition | OpenAPI3Definition | AsyncAPIDefinition,
  disabled?: boolean,
}) => {
  const { t } = useTranslation()

  const menuItems = useMemo(() => API_DOWNLOAD_FORMATS.map(format => (
    <DownloadApiLink
      key={format}
      label={format}
      format={format}
      title={title}
      definition={definition}
    />
  )), [title, definition])

  return (
    <NestedDropdown
      menuItems={menuItems}
      dropdownButton={t('components.ui.apiViewer.downloadApi.label')}
      disabled={disabled}
    />
  )
}
